import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { RiShieldLine, RiLogoutBoxLine } from 'react-icons/ri';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="text-center animate-fade-in-up">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-950 border border-red-800 rounded-2xl mb-5">
          <RiShieldLine className="w-8 h-8 text-red-500" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Access Denied</h1>
        <p className="text-slate-400 text-sm mb-6 max-w-xs mx-auto">
          You don't have permission to access this page. Please sign in with the correct role.
        </p>
        <button
          onClick={handleLogout}
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold px-5 py-2.5 rounded-lg transition-all duration-150 active:scale-[0.98]"
        >
          <RiLogoutBoxLine className="w-4 h-4" />
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
